import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c('h1',[_vm._v("Sorry")]),_c('h3',[_vm._v("The page your are looking for cannot be found. Please "),_c('a',{attrs:{"href":`mailto:${_vm.supportEmail}`}},[_vm._v("contact us")]),_vm._v(" for assistance.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }